import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import CollapsibleComponent from './component';

export class CollapsibleContentModel extends BaseContentModel {
  
  static _slots = {    
    titleContent: BaseContentModel,
    innerContent: BaseContentModel,
  }
  
  Component = CollapsibleComponent

  @observable 
  /* @slot */ titleContent = null

  @observable 
  /* @slot */ innerContent = null
}
export default CollapsibleContentModel


// WEBPACK FOOTER //
// ./app_modules/collapsible-activity/contentmodel.js